export default function (state) {
    state.PaymentOperationID = 1;
    state.CategoryId = 0;
    state.PaymentTypeId = 0;
    state.CashId = 0;
    state.PaymentAccountId = 0;
    state.Sum = 0;
    state.BankCommission = 0;
    state.CurrencyId = 1;
    state.AccountNumber = '';
    state.PaymentDate = '';
    state.DocumentNumber = '';
    state.Comment = '';
    state.PaymentDetails = [];
    state.loading = false;
}